import { render, staticRenderFns } from "./SubscriberEditor.vue?vue&type=template&id=d6a61030&scoped=true"
import script from "./SubscriberEditor.vue?vue&type=script&lang=js"
export * from "./SubscriberEditor.vue?vue&type=script&lang=js"
import style0 from "./SubscriberEditor.vue?vue&type=style&index=0&id=d6a61030&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a61030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6a61030')) {
      api.createRecord('d6a61030', component.options)
    } else {
      api.reload('d6a61030', component.options)
    }
    module.hot.accept("./SubscriberEditor.vue?vue&type=template&id=d6a61030&scoped=true", function () {
      api.rerender('d6a61030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Notifications/SubscriberEditor.vue"
export default component.exports